import { uiGameManager } from '../../EntryShared.ts';
import { PIXI } from '@colonist/pixi';
export class UIGameToolTipPointerView extends PIXI.Graphics {
    clampX(x) {
        const margin = this.toolTipCornerRadius + this.w / 2;
        const leftLimit = margin;
        const rightLimit = uiGameManager.canvasController.appW - margin;
        return Math.min(Math.max(x, leftLimit), rightLimit);
    }
    drawToolTipPointer(x, y, pointDown = true) {
        const h = pointDown ? this.itemSize / 8 : -this.itemSize / 8;
        const trianglePoints = [
            x - this.w / 2,
            y,
            x + this.w / 2,
            y,
            x,
            y + h
        ];
        this.beginFill(this.backgroundColor);
        this.drawPolygon(trianglePoints);
        this.endFill();
    }
    constructor(container, x, viewToPlaceNear, toolTipCornerRadius, backgroundColor){
        super(), this.itemSize = uiGameManager.canvasController.itemSize;
        this.backgroundColor = backgroundColor;
        this.w = this.itemSize / 4;
        this.container = container;
        this.viewToPlaceNear = viewToPlaceNear;
        this.toolTipCornerRadius = toolTipCornerRadius;
        const toolTipIsAboveView = this.viewToPlaceNear.getGlobalPosition().y > this.container.getGlobalPosition().y;
        const y = toolTipIsAboveView ? container.height : 0;
        this.drawToolTipPointer(this.clampX(x), y, toolTipIsAboveView);
        container.addChild(this);
    }
}
